'use strict';

var React = require('react');
var Color = require('color');
var ReactIs = require('react-is');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Color__default = /*#__PURE__*/_interopDefaultLegacy(Color);
var ReactIs__default = /*#__PURE__*/_interopDefaultLegacy(ReactIs);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var NodeTypes;
(function (NodeTypes) {
    NodeTypes["SHAPE"] = "shape";
    NodeTypes["LINE"] = "line";
    NodeTypes["TEXT_LINK"] = "text-link";
    NodeTypes["TEXT_BULLET"] = "text-bullet";
    NodeTypes["SLIDE"] = "slide";
    NodeTypes["MASTER_SLIDE"] = "master-slide";
    NodeTypes["IMAGE"] = "image";
    NodeTypes["PRESENTATION"] = "presentation";
})(NodeTypes || (NodeTypes = {}));
var TextLink = NodeTypes.TEXT_LINK;
var isTextLink = function (el) {
    return el.type === NodeTypes.TEXT_LINK;
};
var TextBullet = NodeTypes.TEXT_BULLET;
var isTextBullet = function (el) {
    return el.type === NodeTypes.TEXT_BULLET;
};
var TextFn = function () { return null; };
TextFn.prototype.isPptxTextElement = true;
TextFn.prototype.Link = TextLink;
TextFn.prototype.Bullet = TextBullet;
var Text = Object.assign(TextFn, {
    Link: TextLink,
    Bullet: TextBullet,
});
// We add a random symbol-ish to the prototype for use in isText
// For some reason a normal el.type == Text doesn't work here when
// the result is bundled
Text.prototype.isPptxTextElement = true;
var isText = function (el) {
    var _a;
    return el.type instanceof Function && ((_a = el.type.prototype) === null || _a === void 0 ? void 0 : _a.isPptxTextElement);
};
NodeTypes.IMAGE;
var isImage = function (el) {
    return el.type === NodeTypes.IMAGE;
};
NodeTypes.SHAPE;
var isShape = function (el) {
    return el.type === NodeTypes.SHAPE;
};
NodeTypes.LINE;
var isLine = function (el) {
    return el.type === NodeTypes.LINE;
};
NodeTypes.SLIDE;
NodeTypes.MASTER_SLIDE;
NodeTypes.PRESENTATION;
var isReactPPTXComponent = function (node) {
    return Object.values(NodeTypes).includes(node.type) || isText(node);
};

var POINTS_TO_INCHES = 1 / 72;
var layoutToInches = function (layout) {
    switch (layout) {
        case "16x10":
            return [10, 6.25];
        case "16x9":
            return [10, 5.625];
        case "4x3":
            return [10, 7.5];
        case "wide":
            return [13.3, 7.5];
    }
};
function isReactElementOrElementArray(
// eslint-disable-next-line @typescript-eslint/ban-types
arr) {
    return React__default["default"].isValidElement(arr);
}
function flattenChildren(children, keys) {
    if (keys === void 0) { keys = []; }
    return React__default["default"].Children.toArray(children).reduce(function (acc, node, nodeIndex) {
        if (ReactIs__default["default"].isFragment(node)) {
            acc.push.apply(acc, flattenChildren(node.props.children, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (ReactIs__default["default"].isElement(node)) {
                if (isReactPPTXComponent(node)) {
                    acc.push(React__default["default"].cloneElement(node, {
                        key: keys.concat(String(node.key)).join("."),
                    }));
                }
                else {
                    // A component that could return/contain react-pptx components,
                    // traverse the tree some more
                    var children_1 = node.props.children;
                    if (node.type instanceof Function) {
                        children_1 = node.type(node.props);
                    }
                    acc.push.apply(acc, flattenChildren(children_1, keys.concat(node.key || nodeIndex)));
                }
            }
            else if (typeof node === "string" || typeof node === "number") {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}

// Normalizer converts and normalizes JSX Presentation trees into internal nodes
var DEFAULT_FONT_SIZE = 18;
var DEFAULT_FONT_FACE = "Arial";
var normalizeHexColor = function (colorString) {
    return Color__default["default"](colorString).hex().substring(1).toUpperCase();
};
var normalizeHexOrComplexColor = function (colorString) {
    var clr = Color__default["default"](colorString);
    // PptxGenJs hex color don't use leading # for hex colors
    var hexColor = clr.hex().substring(1).toUpperCase();
    if (clr.alpha() === 1) {
        return hexColor;
    }
    else {
        return {
            type: "solid",
            color: hexColor,
            // Alpha is actually transparency (ie. 0=opaque, 1=fully transparent)
            alpha: 100 - Math.round(clr.alpha() * 100),
        };
    }
};
var normalizeText = function (t) {
    if (isReactElementOrElementArray(t)) {
        return flattenChildren(t).reduce(function (textParts, el) {
            if (React__default["default"].isValidElement(el)) {
                var bullet_1;
                if (isTextBullet(el)) {
                    // We know the intention is for a bullet, so pass on true if no customisation required
                    var _a = el.props, children_1 = _a.children, style_1 = _a.style, rtlMode_1 = _a.rtlMode, lang_1 = _a.lang, bulletProps = __rest(_a, ["children", "style", "rtlMode", "lang"]);
                    bullet_1 = Object.keys(bulletProps).length ? bulletProps : true;
                    var normalizedChildren_1 = normalizeText(children_1);
                    var normalizedParentColor = (style_1 === null || style_1 === void 0 ? void 0 : style_1.color)
                        ? normalizeHexColor(style_1.color)
                        : undefined;
                    var parentStyle_1 = __assign(__assign({}, (style_1 || {})), { color: normalizedParentColor });
                    // Make `breakLine = false` for all child components except the last one
                    // (so every child will sit within the same bullet point)
                    var childParts = normalizedChildren_1.map(function (childPart, index) { return (__assign(__assign({ rtlMode: rtlMode_1, lang: lang_1, bullet: index === 0 ? bullet_1 : undefined }, childPart), { style: __assign(__assign({}, parentStyle_1), childPart.style), breakLine: index + 1 >= normalizedChildren_1.length })); });
                    return textParts.concat(childParts);
                }
                var link = void 0;
                if (isTextLink(el)) {
                    // props extracted here again so that ts can infer them as TextLinkProps
                    var props = el.props;
                    if ("url" in props) {
                        link = { url: props.url, tooltip: props.tooltip };
                    }
                    else if (props.slide) {
                        link = { slide: props.slide, tooltip: props.tooltip };
                    }
                }
                var _b = el.props, children = _b.children, style = _b.style, rtlMode = _b.rtlMode, lang = _b.lang;
                return textParts.concat({
                    text: children,
                    rtlMode: rtlMode,
                    lang: lang,
                    link: link,
                    style: __assign(__assign({}, (style || {})), { color: (style === null || style === void 0 ? void 0 : style.color) ? normalizeHexColor(style.color) : undefined }),
                });
            }
            else {
                return textParts.concat({
                    text: el.toString(),
                    style: {},
                });
            }
        }, []);
    }
    else if (Array.isArray(t)) {
        return t.reduce(function (prev, cur) { return prev.concat(normalizeText(cur)); }, []);
    }
    else if (["number", "string"].includes(typeof t)) {
        return [
            {
                text: t.toString(),
                style: {},
            },
        ];
    }
    else {
        throw new TypeError("Invalid TextChild found; only strings/numbers/arrays of them are accepted");
    }
};
var PERCENTAGE_REGEXP = /^\d+%$/;
var normalizeCoordinate = function (x, _default) {
    if (typeof x === "string") {
        if (!PERCENTAGE_REGEXP.test(x)) {
            throw new TypeError("\"".concat(x, "\" is invalid position; string positions must be of format '[0-9]+%'"));
        }
        return x;
    }
    else if (typeof x === "number") {
        return x;
    }
    return _default;
};
var normalizeSlideObject = function (node) {
    var _a, _b, _c, _d, _e;
    if (!node.props.style) {
        throw new TypeError("A ".concat(node.type, " object is missing style attribute"));
    }
    if (isLine(node)) {
        return {
            kind: "line",
            x1: node.props.x1,
            y1: node.props.y1,
            x2: node.props.x2,
            y2: node.props.y2,
            style: {
                color: node.props.style.color
                    ? normalizeHexColor(node.props.style.color)
                    : null,
                width: (_a = node.props.style.width) !== null && _a !== void 0 ? _a : null,
            },
        };
    }
    var _f = node.props.style, origX = _f.x, origY = _f.y, origW = _f.w, origH = _f.h;
    var normalizedCoordinates = {
        x: normalizeCoordinate(origX, 0),
        y: normalizeCoordinate(origY, 0),
        w: normalizeCoordinate(origW, 1),
        h: normalizeCoordinate(origH, 1),
    };
    if (isText(node)) {
        var style = node.props.style;
        return {
            kind: "text",
            text: node.props.children !== undefined
                ? normalizeText(node.props.children)
                : [],
            style: __assign(__assign(__assign({}, style), normalizedCoordinates), { color: style.color ? normalizeHexColor(style.color) : null, fontFace: (_b = style.fontFace) !== null && _b !== void 0 ? _b : DEFAULT_FONT_FACE, fontSize: (_c = style.fontSize) !== null && _c !== void 0 ? _c : DEFAULT_FONT_SIZE }),
        };
    }
    else if (isImage(node)) {
        return {
            kind: "image",
            src: node.props.src,
            style: __assign(__assign({}, normalizedCoordinates), { sizing: (_d = node.props.style.sizing) !== null && _d !== void 0 ? _d : null }),
        };
    }
    else if (isShape(node)) {
        return {
            kind: "shape",
            type: node.props.type,
            text: node.props.children !== undefined
                ? normalizeText(node.props.children)
                : null,
            style: __assign(__assign({}, normalizedCoordinates), { backgroundColor: node.props.style.backgroundColor
                    ? normalizeHexOrComplexColor(node.props.style.backgroundColor)
                    : null, borderColor: node.props.style.borderColor
                    ? normalizeHexColor(node.props.style.borderColor)
                    : null, borderWidth: (_e = node.props.style.borderWidth) !== null && _e !== void 0 ? _e : null }),
        };
    }
    else {
        throw new Error("unknown slide object");
    }
};
var isPresent = function (x) {
    return x !== null;
};
var normalizeSlide = function (_a) {
    var _b, _c, _d, _e, _f;
    var props = _a.props;
    var slide = {
        masterName: (_b = props.masterName) !== null && _b !== void 0 ? _b : null,
        hidden: (_c = props.hidden) !== null && _c !== void 0 ? _c : false,
        backgroundColor: ((_d = props === null || props === void 0 ? void 0 : props.style) === null || _d === void 0 ? void 0 : _d.backgroundColor)
            ? normalizeHexOrComplexColor(props.style.backgroundColor)
            : null,
        backgroundImage: (_f = (_e = props === null || props === void 0 ? void 0 : props.style) === null || _e === void 0 ? void 0 : _e.backgroundImage) !== null && _f !== void 0 ? _f : null,
        objects: [],
    };
    if (props.children) {
        slide.objects = flattenChildren(props.children)
            .map(normalizeSlideObject)
            .filter(isPresent);
    }
    return slide;
};
var normalizeMasterSlide = function (_a) {
    var _b, _c, _d;
    var props = _a.props;
    var slide = {
        name: props.name,
        backgroundColor: ((_b = props === null || props === void 0 ? void 0 : props.style) === null || _b === void 0 ? void 0 : _b.backgroundColor)
            ? normalizeHexOrComplexColor(props.style.backgroundColor)
            : null,
        backgroundImage: (_d = (_c = props === null || props === void 0 ? void 0 : props.style) === null || _c === void 0 ? void 0 : _c.backgroundImage) !== null && _d !== void 0 ? _d : null,
        objects: [],
    };
    if (props.children) {
        slide.objects = flattenChildren(props.children)
            .map(normalizeSlideObject)
            .filter(isPresent);
    }
    return slide;
};
var normalizeJsx = function (_a) {
    var _b;
    var props = _a.props;
    var pres = {
        layout: (_b = props.layout) !== null && _b !== void 0 ? _b : "16x9",
        masterSlides: {},
        slides: [],
        author: props.author,
        company: props.company,
        revision: props.revision,
        subject: props.subject,
        title: props.title,
    };
    if (props.children) {
        var children = flattenChildren(props.children);
        pres.slides = children
            .filter(function (child) { return child.type === NodeTypes.SLIDE; })
            .map(normalizeSlide);
        var masterSlides = children
            .filter(function (child) { return child.type === NodeTypes.MASTER_SLIDE; })
            .map(normalizeMasterSlide);
        pres.masterSlides = Object.fromEntries(masterSlides.map(function (slide) { return [slide.name, slide]; }));
    }
    return pres;
};

var normalizedColorToCSS = function (color) {
    if (typeof color === "string") {
        return "#".concat(color);
    }
    else {
        var r = parseInt(color.color.substring(0, 2), 16);
        var g = parseInt(color.color.substring(2, 4), 16);
        var b = parseInt(color.color.substring(4, 6), 16);
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(1 - color.alpha / 100, ")");
    }
};
var SlideObjectShape = function (_a) {
    var shape = _a.shape;
    var baseStyle = {
        width: "100%",
        height: "100%",
        backgroundColor: shape.style.backgroundColor
            ? normalizedColorToCSS(shape.style.backgroundColor)
            : undefined,
    };
    if (shape.type === "rect") {
        return React__namespace.createElement("div", { style: baseStyle });
    }
    else if (shape.type === "ellipse") {
        return React__namespace.createElement("div", { style: __assign(__assign({}, baseStyle), { borderRadius: "100%" }) });
    }
    else {
        return (React__namespace.createElement("div", { style: __assign(__assign({}, baseStyle), { display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }) },
            React__namespace.createElement("div", { style: {
                    background: "rgba(0, 0, 0, 0) repeating-linear-gradient(45deg, yellow,  yellow 10px, black 10px, black 20px) repeat scroll 0% 0%",
                    padding: 5,
                    textAlign: "center",
                } },
                React__namespace.createElement("span", { style: { backgroundColor: "white", padding: 2 } },
                    "no preview for \"",
                    shape.type,
                    "\""))));
    }
};
var getTextStyleForPart = function (style, dimensions, slideWidth) {
    var _a;
    var pointsToPx = function (points) {
        return ((points * POINTS_TO_INCHES) / dimensions[0]) * slideWidth;
    };
    var margin = undefined;
    if (style.margin !== undefined) {
        if (Array.isArray(style.margin)) {
            margin = style.margin
                .map(function (marginItem) { return "".concat(pointsToPx(marginItem), "px"); })
                .join(", ");
        }
        else {
            margin = "0 ".concat(pointsToPx(style.margin), "px");
        }
    }
    var verticalAlign;
    switch (style.verticalAlign) {
        case "top":
            verticalAlign = "start";
            break;
        case "middle":
            verticalAlign = "center";
            break;
        case "bottom":
            verticalAlign = "end";
            break;
    }
    var textDecorationParts = [];
    if (style.underline) {
        textDecorationParts.push("underline");
    }
    if (style.strike) {
        textDecorationParts.push("line-through");
    }
    var textDecoration = textDecorationParts.length
        ? textDecorationParts.join(" ")
        : undefined;
    return {
        fontSize: style.fontSize ? pointsToPx(style.fontSize) : undefined,
        color: style.color ? normalizedColorToCSS(style.color) : undefined,
        fontFamily: (_a = style.fontFace) !== null && _a !== void 0 ? _a : undefined,
        fontWeight: style.bold ? "bold" : undefined,
        fontStyle: style.italic ? "italic" : undefined,
        padding: margin,
        lineHeight: style.lineSpacing
            ? "".concat(pointsToPx(style.lineSpacing), "px")
            : undefined,
        letterSpacing: style.charSpacing
            ? "".concat(pointsToPx(style.charSpacing), "px")
            : undefined,
        textDecoration: textDecoration,
        marginTop: style.paraSpaceBefore
            ? "".concat(pointsToPx(style.paraSpaceBefore), "px")
            : undefined,
        marginBottom: style.paraSpaceAfter
            ? "".concat(pointsToPx(style.paraSpaceAfter), "px")
            : undefined,
        transform: style.rotate ? "rotate(".concat(style.rotate, "deg)") : undefined,
        alignItems: verticalAlign,
        backgroundColor: style.backgroundColor ? normalizedColorToCSS(style.backgroundColor) : undefined
    };
};
var TextPreview = function (_a) {
    var parts = _a.parts, dimensions = _a.dimensions, slideWidth = _a.slideWidth, subscript = _a.subscript, superscript = _a.superscript;
    // Perform a first pass to collect any consecutive bullet points into the same
    // <ul> or <ol>
    var listsOfParts = parts.reduce(function (collectedSoFar, part) {
        if (!part.bullet) {
            return __spreadArray(__spreadArray([], collectedSoFar, true), [{ parts: [part] }], false);
        }
        var previousItem = collectedSoFar[collectedSoFar.length - 1];
        var bulletType = part.bullet === true ? "bullet" : part.bullet.type;
        if (previousItem && previousItem.listType === bulletType) {
            previousItem.parts.push(part);
            return collectedSoFar;
        }
        else {
            return __spreadArray(__spreadArray([], collectedSoFar, true), [{ listType: bulletType, parts: [part] }], false);
        }
    }, []);
    var children = (React__namespace.createElement(React__namespace.Fragment, null, listsOfParts.reduce(function (elements, _a, index) {
        var listType = _a.listType, parts = _a.parts;
        if (!listType) {
            var nonListParts = parts.map(function (part, partIndex) {
                var style = getTextStyleForPart(part.style, dimensions, slideWidth);
                if (part.link) {
                    if (part.link.url) {
                        return (React__namespace.createElement("a", { key: "".concat(index, "-").concat(partIndex), title: part.link.tooltip, href: part.link.url, style: style }, part.text));
                    }
                    else if (part.link.slide) {
                        // Not supported yet
                        return (React__namespace.createElement("a", { key: "".concat(index, "-").concat(partIndex), title: part.link.tooltip, style: __assign(__assign({}, style), { cursor: "not-allowed" }) }, part.text));
                    }
                }
                else if (part.style.subscript) {
                    return (React__namespace.createElement("sub", { key: "".concat(index, "-").concat(partIndex), style: style }, part.text));
                }
                else if (part.style.superscript) {
                    return (React__namespace.createElement("sup", { key: "".concat(index, "-").concat(partIndex), style: style }, part.text));
                }
                else {
                    return (React__namespace.createElement("span", { key: "".concat(index, "-").concat(partIndex), style: style }, part.text));
                }
            });
            return __spreadArray(__spreadArray([], elements, true), nonListParts, true);
        }
        else {
            var listParts = parts.map(function (part, partIndex) {
                var style = getTextStyleForPart(part.style, dimensions, slideWidth);
                return (React__namespace.createElement("li", { key: partIndex, style: style }, part.text));
            });
            var listElement = listType === "number" ? (React__namespace.createElement("ol", { key: index }, listParts)) : (React__namespace.createElement("ul", { key: index }, listParts));
            return __spreadArray(__spreadArray([], elements, true), [listElement], false);
        }
    }, [])));
    if (superscript) {
        children = React__namespace.createElement("sup", null, children);
    }
    else if (subscript) {
        children = React__namespace.createElement("sub", null, children);
    }
    return React__namespace.createElement("div", null, children);
};
var constrainObjectFit = function (sizing) {
    var fit = sizing === null || sizing === void 0 ? void 0 : sizing.fit;
    if (fit === "contain" || fit === "cover") {
        return fit;
    }
    else {
        return undefined;
    }
};
var calculatePercentage = function (value, total) {
    return typeof value === "number"
        ? (value / total) * 100
        : parseInt(value, 10);
};
var SlideObjectPreview = function (_a) {
    var _b;
    var object = _a.object, dimensions = _a.dimensions, slideWidth = _a.slideWidth, drawBoundingBoxes = _a.drawBoundingBoxes;
    if (object.kind === 'line') {
        var x1 = object.x1, x2 = object.x2, y1 = object.y1, y2 = object.y2;
        var thickness = (_b = object.style.width) !== null && _b !== void 0 ? _b : 1;
        // from https://stackoverflow.com/a/8673281/13065068
        var length_1 = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        var centerX = ((x1 + x2) / 2) - (length_1 / 2);
        var centerY = ((y1 + y2) / 2);
        var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
        return (React__namespace.createElement("div", { style: {
                position: "absolute",
                left: "".concat(calculatePercentage(centerX, dimensions[0]), "%"),
                top: "".concat(calculatePercentage(centerY, dimensions[1]), "%"),
                width: "".concat(calculatePercentage(length_1, dimensions[0]), "%"),
                transform: "rotate(".concat(angle, "deg) translateY(").concat(thickness / 2, "px)"),
                height: thickness,
                backgroundColor: object.style.color ? normalizedColorToCSS(object.style.color) : undefined
            } }));
    }
    var xPercentage = calculatePercentage(object.style.x, dimensions[0]);
    var yPercentage = calculatePercentage(object.style.y, dimensions[1]);
    var wPercentage = calculatePercentage(object.style.w, dimensions[0]);
    var hPercentage = calculatePercentage(object.style.h, dimensions[1]);
    return (React__namespace.createElement("div", { style: {
            position: "absolute",
            left: "".concat(xPercentage, "%"),
            top: "".concat(yPercentage, "%"),
            width: "".concat(wPercentage, "%"),
            height: "".concat(hPercentage, "%"),
            outline: drawBoundingBoxes ? "1px solid red" : undefined,
            boxSizing: "border-box",
        } }, object.kind === "text" ? (React__namespace.createElement("div", { style: __assign(__assign({}, getTextStyleForPart(object.style, dimensions, slideWidth)), { height: "100%", display: "flex", textAlign: object.style.align, justifyContent: object.style.align }) },
        React__namespace.createElement(TextPreview, { parts: object.text, subscript: object.style.subscript, superscript: object.style.superscript, dimensions: dimensions, slideWidth: slideWidth }))) : object.kind === "image" ? (React__namespace.createElement("img", { src: object.src.kind === "data"
            ? "data:".concat(object.src[object.src.kind])
            : object.src[object.src.kind], style: {
            width: "100%",
            height: "100%",
            objectFit: constrainObjectFit(object.style.sizing),
        } })) : (React__namespace.createElement(SlideObjectShape, { shape: object }))));
};
var useResize = function (myRef) {
    var _a = React__namespace.useState(0), width = _a[0], setWidth = _a[1];
    var _b = React__namespace.useState(0), height = _b[0], setHeight = _b[1];
    React__namespace.useEffect(function () {
        var handleResize = function () {
            setWidth(myRef.current.offsetWidth);
            setHeight(myRef.current.offsetHeight);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [myRef]);
    return { width: width, height: height };
};
var SlidePreview = function (_a) {
    var _b, _c, _d;
    var slide = _a.slide, masterSlide = _a.masterSlide, dimensions = _a.dimensions, slideStyle = _a.slideStyle, drawBoundingBoxes = _a.drawBoundingBoxes;
    var ref = React__namespace.useRef(null);
    var width = useResize(ref).width;
    return (React__namespace.createElement("div", { ref: ref, style: __assign({ width: "100%", height: width / (dimensions[0] / dimensions[1]), backgroundColor: slide.backgroundColor
                ? normalizedColorToCSS(slide.backgroundColor)
                : "white", backgroundImage: slide.backgroundImage && ((_b = slide.backgroundImage) === null || _b === void 0 ? void 0 : _b.kind) === "path"
                ? "url(\"".concat(slide.backgroundImage.path, "\")")
                : "url(\"data:".concat((_c = slide.backgroundImage) === null || _c === void 0 ? void 0 : _c.data, "\")"), position: "relative" }, slideStyle) }, (_d = masterSlide === null || masterSlide === void 0 ? void 0 : masterSlide.objects) === null || _d === void 0 ? void 0 :
        _d.map(function (o, i) { return (React__namespace.createElement(SlideObjectPreview, { key: i, object: o, dimensions: dimensions, slideWidth: width, drawBoundingBoxes: drawBoundingBoxes })); }),
        slide.objects.map(function (o, i) { return (React__namespace.createElement(SlideObjectPreview, { key: i, object: o, dimensions: dimensions, slideWidth: width, drawBoundingBoxes: drawBoundingBoxes })); })));
};
var Preview = function (props) {
    if (!props.children) {
        return null;
    }
    var presentationNode = React__namespace.Children.only(props.children);
    try {
        var normalized_1 = normalizeJsx(presentationNode);
        return (React__namespace.createElement("div", { style: {
                width: "100%",
            } }, normalized_1.slides.map(function (slide, i) { return (React__namespace.createElement(SlidePreview, { key: i, slide: slide, masterSlide: (slide.masterName && normalized_1.masterSlides[slide.masterName]) || undefined, dimensions: layoutToInches(normalized_1.layout), slideStyle: props.slideStyle, drawBoundingBoxes: !!props.drawBoundingBoxes })); })));
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        return (React__namespace.createElement("div", { style: {
                width: "100%",
                color: "orange",
            } },
            "invalid JSX: ",
            e.toString()));
    }
};

module.exports = Preview;
